import * as EventConstants from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import ProteinActions from 'molbio/proteins/ProteinActions';
import {Protein} from 'molbio/proteins/util/ProteinConstants';
import notifications, {Response, ResponseJSON} from 'notifications';

type ProteinUpdateErrorResponse = Response & {responseJSON?: ResponseJSON & {updatedProtein?: Protein}};

/**
 * Error handler for any protein DAO operations
 */
const handleProteinUpdateError = (e: ProteinUpdateErrorResponse): void => {
  // If the protein was out of date, we'll get an error with the new protein.
  const protein = e.responseJSON && e.responseJSON.updatedProtein;
  if (protein) {
    AppDispatcher.dispatch({
      actionType: EventConstants.PROTEIN_UPDATE_COMPLETED,
      proteinId: protein.id,
      newProtein: protein,
    });
    ProteinActions.fetchVersions(protein.id);
  }
  notifications.notifyError(e);
};

export default handleProteinUpdateError;
